import React from 'react'

export interface Holdout {
    arm: string
    share: number
    assigned_at: string
}

const HOLDOUT_LABELS: Record<string, string> = {
    holdout: 'Started directly for comparison',
    treatment: 'Warm-up (comparison group)',
}

/** What the owner sees about the holdout comparison of a campaign: the label of its group, or nothing. */
export const holdoutLabel = (holdout?: Holdout | null): string | null =>
    holdout ? HOLDOUT_LABELS[holdout.arm] || null : null

interface WarmupHoldoutNoteProps {
    holdout?: Holdout | null
    /** A strip of its own, for a campaign that started directly and so has no warm-up panel. */
    strip?: boolean
}

const WarmupHoldoutNote: React.FC<WarmupHoldoutNoteProps> = ({ holdout, strip = false }) => {
    const label = holdoutLabel(holdout)
    if (!holdout || !label) return null

    const text = `This licence compares warm-ups with direct starts: ${holdout.share}% of the campaigns Turba would have started with a warm-up are started directly instead.`
    const note = (
        <span
            data-testid="warmup-holdout-label"
            title={text}
            className="tw:rounded tw:border tw:border-[#3B5168] tw:px-1.5 tw:py-0.5 tw:text-xs tw:text-gray-200"
        >
            {label}
        </span>
    )
    if (!strip) return note

    return (
        <div
            data-testid="warmup-holdout-strip"
            className="tw:sticky tw:left-0 tw:flex tw:w-[1000px] tw:items-center tw:gap-3 tw:border-b tw:border-[#2B3B4C] tw:bg-[#0B1E33] tw:px-6 tw:py-2 tw:text-sm tw:text-white"
        >
            {note}
            <span className="tw:text-gray-200">{text}</span>
        </div>
    )
}

export default WarmupHoldoutNote
